import { lazy } from "react";
import { Link, createBrowserRouter } from "react-router-dom";

/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout.js"));
const Help = lazy(() => import("../views/Help.js"));
const SDWANObservability = lazy(() => import("../views/managed-services/SDWANObservability.js"));

/*****Routes******/
///https://blog.logrocket.com/complete-guide-authentication-with-react-router-v6/#creating-protected-routes TIM TODO

const router = () => createBrowserRouter(
  [
    {
      path: "/",
      element: <FullLayout />,
      children: [
        { path: "/", title: "SDWAN Observability", exact: true, element: <SDWANObservability /> },
        { path: "/help", title: "Help", exact: true, element: <Help /> },
        { path: "managed-services/sdwan-observability", title: "SDWAN Observability", exact: true, element: <SDWANObservability /> },
      ],
    },
    {
      path: "*",
      element: <NoMatch />,
    },
  ]
);

function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}

export default router;
